import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import type { FormRenderProps } from '#src/components/form/Form/index.tsx';
import { GraphqlForm } from '#src/components/form/Form/index.tsx';
import { useWalletContext } from '#src/contexts/wallet/index.ts';
import { useLazyQuery } from '#src/hooks/graphql/useLazyQuery.ts';
import { useEvents } from '#src/lib/events/useEvents.ts';

import type {
  CheckManagernameAvailability,
  CheckManagernameAvailabilityVariables,
} from './__generated__/index.graphql.ts';

const CHECK_MANAGERNAME_AVAILABILITY_QUERY = gql`
  query CheckManagernameAvailability($nickname: String!) {
    isNicknameAvailable(nickname: $nickname)
  }
` as TypedDocumentNode<
  CheckManagernameAvailability,
  CheckManagernameAvailabilityVariables
>;

type NicknameProps = {
  sport: Sport;
  onSuccess: ({ nickname }: { nickname?: string }) => void;
  onError: () => void;
  render: FormRenderProps;
};

export const NicknameForm = ({
  sport,
  onSuccess,
  onError,
  render,
}: NicknameProps) => {
  const { signUp } = useWalletContext();
  const [search] = useLazyQuery(CHECK_MANAGERNAME_AVAILABILITY_QUERY);
  const track = useEvents();

  return (
    <GraphqlForm<{ nickname?: string }>
      onSubmit={async ({ nickname }, onResult, onCancel) => {
        const { data } = await search({ variables: { nickname } });

        if (data?.isNicknameAvailable) {
          signUp(nickname, sport);
          onResult({ nickname });
          track('Choose Signup Manager Name', {});
        } else {
          track('Fail Signup Manager Name', {});
          onResult({
            error: 'Username is already taken',
          });
          onCancel();
        }
      }}
      onSuccess={onSuccess}
      onError={onError}
      render={render}
    />
  );
};
